import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'priority'

const OPTIONS = [
  {
    value: 'Comfort',
    translationKey: 'pages.onboarding.priority.options.comfort',
    subtextKey: 'pages.onboarding.priority.subtexts.comfort',
    emoji: '🛋️',
  },
  {
    value: 'Style',
    translationKey: 'pages.onboarding.priority.options.style',
    subtextKey: 'pages.onboarding.priority.subtexts.style',
    emoji: '✨',
  },
  {
    value: 'Functionality',
    translationKey: 'pages.onboarding.priority.options.functionality',
    subtextKey: 'pages.onboarding.priority.subtexts.functionality',
    emoji: '📐',
  },
  {
    value: 'Sustainability',
    translationKey: 'pages.onboarding.priority.options.sustainability',
    subtextKey: 'pages.onboarding.priority.subtexts.sustainability',
    emoji: '🌱',
  },
  {
    value: 'Not sure yet',
    translationKey: 'pages.onboarding.priority.options.notSure',
    subtextKey: 'pages.onboarding.priority.subtexts.notSure',
    emoji: '🤔',
  },
]

export default function PriorityPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    // Find the selected option to get both value and subtext
    const selectedOption = OPTIONS.find((option) => option.value === value)
    const emoji = selectedOption ? selectedOption.emoji : ''

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's more important to you?",
      answer_key: value,
      answer: `${emoji} , ${t(selectedOption?.translationKey ?? '')}`,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.priority.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
